<template>
  <v-container>
    <Breadcrumbs :breadcrumbs="breadcrumbs" />
    <v-data-table
      :headers="headers"
      :items="list"
      class="elevation-1"
      hide-default-footer
      disable-pagination
    >
      <template v-slot:top>
        <template>
          <v-btn
            class="float-right mt-3 mr-3"
            color="primary"
            dark
            @click="addDialog = true"
            >New Author</v-btn
          >
        </template>
        <v-toolbar flat color="white">
          <v-toolbar-title>Authors</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
        </v-toolbar>
        <v-row class="ml-2 mr-2">
          <v-col cols="12" sm="6" md="2" class="pt-0 pb-0">
            <v-text-field
              v-model="filter_name"
              label="Auther Name"
              outlined
              dense
              @keyup="searchFilter"
            ></v-text-field>
          </v-col>
        </v-row>
      </template>
      <template v-slot:[`item.authorid`]="{ item }">
        {{ list .map(function (x) { return x.authorid; }) .indexOf(item.authorid) + 1 }}
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-icon
          title="Edit"
          small
          class="mr-2"
          color="#1976D2"
          @click.stop="editItemMethod(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          title="Delete"
          small
          @click.stop="deleteItemMethod(item)"
          color="#FF5252"
        >
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>
    <template>
      <div class="text-center">
        <v-pagination
          v-model="page"
          :length="PagesNumber"
          :total-visible="7"
          @input="changePage($event)"
        ></v-pagination>
      </div>
    </template>
    <AddAuthor :addDialog="addDialog" v-on:DialogClose="DialogClose($event)" />
    <EditAuthor :editDialog="editDialog" :editItem="editItem" v-on:DialogClose="DialogClose($event)" />
    <DeleteAuthor :deleteDialog="deleteDialog" :deleteItem="deleteItem"  v-on:DialogClose="DialogClose($event)" />
  </v-container>
</template>
<script>
import Breadcrumbs from "@/components/Global/Breadcrumbs";
import AddAuthor from "@/components/Authors/AddAuthor";
import EditAuthor from "@/components/Authors/EditAuthor";
import DeleteAuthor from "@/components/Authors/DeleteAuthor";
export default {
  data: () => ({
    breadcrumbs: [
      {
        text: "Dashboard",
        disabled: false,
        to: "/",
      },
      {
        text: "Authors",
        disabled: true,
      },
    ],
    headers: [
      { text: "#", value: "authorid" },
      { text: "Author Name", value: "authorname" },
      { text: "Action ", value: "action" },
    ],
    list: [],
    page: 1,
    PagesNumber: 0,
    pageUrl: 1,
    filter_name: "",
    addDialog: false,
    editDialog: false,
    deleteDialog: false,
    editItem: {},
    deleteItem: {},
  }),
  mounted() {
    this.getAllAuthors();
    this.filterStatmint = "&filter[authorname]=" + this.filter_name;
  },
  components: {
    Breadcrumbs, AddAuthor, EditAuthor, DeleteAuthor,
  },
  methods: {
    getAllAuthors() {
      this.$store
        .dispatch(
          "GetFromAPI",
          "/admin/author?per_page=20&page=" + this.pageUrl + this.filterStatmint
        )
        .then((response) => {
          this.PagesNumber = response["data"]["meta"]["last_page"];
          this.list = response["data"]["data"];
        });
    },
    changePage(val) {
      this.pageUrl = val;
      this.getAllAuthors();
    },
    searchFilter() {
      this.pageUrl = 1;
      this.filterStatmint = "&filter[authorname]=" + this.filter_name;
      this.getAllAuthors();
    },
    editItemMethod(item) {
      this.editItem = { ...item };
      this.editDialog = true;
    },
    deleteItemMethod(item) {
      this.deleteItem = { ...item };
      this.deleteDialog = true;
    },
    DialogClose(val) {
      if (val == true) {
        this.getAllAuthors();
      }
      this.addDialog = false;
      this.editDialog = false;
      this.deleteDialog = false;
    },
  },
};
</script>